export function weWouldAppreciateIfYouCouldShareInfo(prisly: string) {
  return `We would appreciate if you could take the time to share some information with us.
Please help us by answering a few questions: https://pris.ly/${prisly}`
}
